<template>
  <div class="flex">
    <div v-if="isSwipeQuestion" class="grid-container">
      <div class="swipe-button-left flex justify-end items-center" :class="{ 'opacity-50': activeSwipeAnswer === selection.answers[1].id }">
        <button class="flex flex-col gap-y-3 items-center cursor-pointer transition-opacity" @click="() => next(selection.answers[1].id)">
          <div
            class="rounded-3xl bg-black text-white text-base py-3 px-8 text-center capitalize"
            @mouseenter="() => setSwipeAnswer(selection.answers[0].id)"
            @mouseleave="() => setSwipeAnswer(null)"
          >
            {{ selection.answers[1].answer }}
          </div>
        </button>
      </div>

      <MoleculeCardRecommendationQuestion
        :id="selection.question.id"
        variant="wide"
        :description="selection.question.description"
        :image="selection.question.image"
        :img-alt="selection.question.id"
        :audio="formattedAudio(selection.question.sound, selection.question.id)"
        :toggle-player-state="() => togglePlayerState(selection.question.id)"
        :audio-is-playing="playerStates?.[selection.question.id]"
        class="question-card basis-full xl:basis-[unset]"
      />

      <div class="swipe-button-right flex items-center" :class="{ 'opacity-50': activeSwipeAnswer === selection.answers[0].id }">
        <button class="flex flex-col gap-y-3 items-center cursor-pointer transition-opacity" @click="() => next(selection.answers[0].id)">
          <div
            class="rounded-3xl bg-black text-white text-base py-3 px-8 text-center capitalize"
            @mouseenter="() => setSwipeAnswer(selection.answers[1].id)"
            @mouseleave="() => setSwipeAnswer(null)"
          >
            {{ selection.answers[0].answer }}
          </div>
        </button>
      </div>
    </div>

    <ul v-else class="flex w-full flex-col justify-center justify-items-center xl:flex-row gap-2 xl:gap-6">
      <li v-for="{ id, answer, description, image, sound } in selection.answers" :key="answer.id" class="basis-0 flex-grow xl:flex-grow-0">
        <MoleculeCardRecommendationQuestion
          :id="id"
          variant="narrow"
          :title="answer"
          :description="description"
          :image="image"
          :img-alt="answer"
          :audio="formattedAudio(sound, id)"
          :toggle-player-state="() => togglePlayerState(id)"
          :navigate-next="() => navigateNext(id)"
          :audio-is-playing="playerStates?.[id]"
        />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  navigateNext: { type: Function, required: true },
  playerStates: { type: Object as PropType<Record<string, any>>, required: true },
  togglePlayerState: { type: Function, required: true },
})

const recommendationsStore = useRecommendationsStore()
const selection = computed(() => recommendationsStore.selection)
const isSwipeQuestion = computed(() => selection.value.question.type === 'tindervraag')
const activeSwipeAnswer = ref<string | null>(null)

const setSwipeAnswer = (id: string | null) => {
  activeSwipeAnswer.value = id
}

const next = (id: string) => {
  props.navigateNext(id)
  setSwipeAnswer(null)
}

const formattedAudio = (sound?: string, id?: string) => {
  return sound
    ? {
        src: sound,
        id,
      }
    : undefined
}
</script>

<style scoped lang="scss">
/* prettier-ignore */
.grid-container {
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto;
  grid-template-areas:
    "question-card question-card question-card question-card"
    ". swipe-button-left swipe-button-right .";
  gap: 24px;

  @media (min-width: 1280px) {
    gap: 36px;
  }

  @media (min-width: 1280px) {
    grid-template-columns: 1fr 341px 341px 1fr;
    grid-template-rows: auto auto;
    grid-template-areas:
    "swipe-button-left question-card question-card swipe-button-right";
    gap: 48px;
  }
}

.question-card {
  grid-area: question-card;
}

.swipe-button-left {
  grid-area: swipe-button-left;
}

.swipe-button-right {
  grid-area: swipe-button-right;
}
</style>
